module.exports = __webpack_public_path__ + "img/card_220140554.19ee208a.jpg";